import type { CashierJwtPayload } from '@matix/types';

/**
 * Which surface a signed-in user lands on: the call-centre agent screen, or
 * the till.
 *
 * ONE signal decides it — `Security_Users.IsCallCenter`, surfaced on the JWT as
 * `permissions.is_call_center` and on the admin Users form as the "Is call
 * center user" checkbox. Tick it and the user is an agent; leave it and they
 * get the till.
 *
 * The POS `Call Center` permission deliberately does NOT route, though it did
 * once, ORed with the checkbox. It is an AUTHORIZATION — it says the agent
 * endpoints are open to you — and a tenant whose "Administration" group holds
 * the entire permission tree grants it without meaning to: migration 046 seeded
 * it under the POS module, the group swept it up with everything else, and
 * every administrator was silently moved off the till with no way back
 * (GL_WEB_pizzata, 2026-08-23 — role 1 held 1,782 grants, including the
 * negative "Not Allow ..." ones nobody means to grant). A permission a
 * superuser holds by construction cannot decide which screen anyone sees.
 *
 * The backend's `isAgent` in callCenter.routes.ts stays the wider OR, so this
 * is a SUBSET of it: everyone routed to the agent screen can call the
 * endpoints. Someone holding only the permission stays on the till and keeps
 * API access, which breaks nothing.
 */
export function isCallCenterAgent(cashier: CashierJwtPayload | null | undefined): boolean {
  return cashier?.permissions?.is_call_center === true;
}
